"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVCRequestEvent = void 0;
var utils_1 = require("./utils");
var EventQueue_1 = require("./EventQueue");
var DVCRequestEvent = /** @class */ (function () {
    function DVCRequestEvent(event, user_id, featureVars) {
        var type = event.type, target = event.target, date = event.date, value = event.value, metaData = event.metaData;
        (0, utils_1.checkParamDefined)('type', type);
        var isCustomEvent = !(type in EventQueue_1.EventTypes);
        this.type = isCustomEvent ? 'customEvent' : type;
        this.customType = isCustomEvent ? type : undefined;
        this.target = target;
        this.user_id = user_id;
        this.clientDate = date || Date.now();
        this.value = value;
        this.featureVars = featureVars || {};
        this.metaData = metaData;
    }
    return DVCRequestEvent;
}());
exports.DVCRequestEvent = DVCRequestEvent;
//# sourceMappingURL=RequestEvent.js.map